import { SCOPE as PARENT_SCOPE } from '../types';
export const SCOPE = `${PARENT_SCOPE}.summary`;
export const INIT = `${SCOPE}/INIT`;

export const FETCH_DATA = `${SCOPE}/FETCH_DATA`;
export const SET_SELECTED_TAB = `${SCOPE}/SET_SELECTED_TAB`;
export const FETCHING = `${SCOPE}/FETCHING`;
export const SET_ERROR = `${SCOPE}/SET_ERROR`;

export const SELECT_SEVERITY = `${SCOPE}/SELECT_SEVERITY`;
export const UN_SELECT_SEVERITY = `${SCOPE}/UN_SELECT_SEVERITY`;
export const SELECT_METRIC = `${SCOPE}/SELECT_METRIC`;
export const UN_SELECT_METRIC = `${SCOPE}/UN_SELECT_METRIC`;
export const SET_SUMMARY_DATA = `${SCOPE}/SET_SUMMARY_DATA`;
export const SET_SEARCH_KEY = `${SCOPE}/SET_SEARCH_KEY`;
export const SET_DATA_FETCHED = `${SCOPE}/SET_DATA_FETCHED`;
export const SET_FILTER = `${SCOPE}/SET_FILTER`;
export const RESET_METRIC_SELECTION = `${SCOPE}/RESET_METRIC_SELECTION`;
export const RESET_TAB_SELECTION = `${SCOPE}/RESET_TAB_SELECTION`;
export const SHOW_ACTIVE_ALERTS = `${SCOPE}/SHOW_ACTIVE_ALERTS`;
export const SET_AI_ALERTS_SUMMARY_TABLE_DATA = `${SCOPE}/SET_AI_ALERTS_SUMMARY_TABLE_DATA`;
export const SET_AI_ALERTS_SUMMARY_TABLE_SORT = `${SCOPE}/SET_AI_ALERTS_SUMMARY_TABLE_SORT`;